/**
 * De pauze na je laatste woord: hoe lang het stil moet zijn voordat de
 * stiltemeter zegt "de zin is klaar" en de opname wegstuurt.
 *
 * WAAROM INSTELBAAR. Korter is sneller: elke milliseconde hier wacht de ander
 * extra op de vertaling. Maar te kort knipt je zin af als je even nadenkt, en
 * dan krijgt de ander een halve gedachte vertaald. Wat goed is, verschilt per
 * gesprek en per persoon. Daarom zet de BEHEERDER hem per kamer, ook tijdens
 * het gesprek. Gevraagd door Giovanni op 19 oktober 2026.
 *
 * Hij geldt voor de hele kamer, dus voor allebei de sprekers.
 */

/** Tot 19 oktober 2026 vast in useSpreken.ts. Elke bestaande kamer houdt dit. */
export const PAUZE_MS_STANDAARD = 1200;

/** Wat de beheerder kan kiezen. Hier en nergens anders, voor server én browser. */
export const PAUZE_KEUZES_MS = [600, 800, 1000, 1200, 1500, 2000, 2500, 3000] as const;

export function isPauzeKeuze(waarde: unknown): waarde is number {
  return typeof waarde === 'number' && (PAUZE_KEUZES_MS as readonly number[]).includes(waarde);
}
